// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textSize-xqfJp.MuiTypography-root{font-size:24px}.defaultIconSize-Z1SaM.MuiSvgIcon-root{font-size:45px}`, "",{"version":3,"sources":["webpack://./src/components/camera/overlays/overlaysStyle.module.scss"],"names":[],"mappings":"AACI,mCACI,cAAA,CAKJ,uCACI,cAAA","sourcesContent":[".textSize{\n    &:global(.MuiTypography-root) {\n        font-size: 24px;\n    }\n}\n\n.defaultIconSize{\n    &:global(.MuiSvgIcon-root) {\n        font-size: 45px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textSize": `textSize-xqfJp`,
	"MuiTypography-root": `MuiTypography-root`,
	"defaultIconSize": `defaultIconSize-Z1SaM`,
	"MuiSvgIcon-root": `MuiSvgIcon-root`
};
export default ___CSS_LOADER_EXPORT___;
